import api from '../../api/'
const state = {
    user:{
        name: localStorage.getItem('name') || null,
        role: localStorage.getItem('role') || null,
        solde: localStorage.getItem('solde') || null,
        type_entite: localStorage.getItem('type_entite') || null
    },
    temp_token: localStorage.getItem('temp_token') || null,
    token: localStorage.getItem('token') || null,
    permissions: JSON.parse(JSON.stringify(localStorage.getItem('permissions'))) == null ? null : JSON.parse(JSON.stringify(localStorage.getItem('permissions'))).split(','),
    info:{}
}

const getters = {
    loggedIn(state){
        return state.token !== null
    },
    get_user(state){
       //state.user.solde = 
        return state.user
    },
    permissions(state){
        return state.permissions
    },
    userInfo(state){
        return state.info
    },
    can: (state) => (permission) => {
        //return state.todos.find(todo => todo.id === id)
        return state.permissions.filter(item => item == permission).length == 0 ? false : true
    }
}
const mutations = {
    login_step_one(state,{temp}){
        state.temp_token = temp
    },
    login_step_two(state,token){
        console.log('mon token ',token)
        state.token = token
    },
    logout(state){
        state.token = null
        state.temp_token = null
        state.permissions = null
    },
    userInfo(state,data){
        state.info = data
    },
    update_user(state,{user}){
        state.user.username = user
    },
    update_permissions(state, new_permissions) {
        new_permissions = new_permissions.map(perm => perm.name)
        localStorage.setItem('permissions', new_permissions)
        state.permissions = new_permissions
        //localStorage.getItem('permissions')
       
    }
}

const actions = {
    login_step_one({commit}, credentials) {
        return new Promise((resolve,reject)=>{
            api.auth.login_step_one(credentials)
            .then(response => {
                console.log('ma reponse : ', response)
                const temp_token = response.data.data.token
                localStorage.setItem('temp_token', temp_token)
                //Récupérer le code sur le serveur
                //localStorage.setItem('secret_code',token)
                console.log('login response')
                console.log(response)
                
                commit('login_step_one', temp_token)
                commit('update_user',credentials.username)
                resolve(response)

                //Redirection
                //this.$router.push({ name : 'SecretCode'})
            })
            .catch(error => {
                console.log('login error')
                console.log(error)
                //return error.response.data
                reject(error)
            })
        })
    },
    login_step_two({commit}, code,actions) { //step 2 to connect
        return new Promise((resolve,reject)=>{
            api.auth.login_step_two(code)
            .then(async response => {
                console.log("rrr", response.data)
                const token = response.data.data.token

                let perm = await api.auth.getUserPermissions(token)
                console.log('mes permissions', perm)
                
                commit('update_permissions', perm.data.data) //met à jour les permissions de l'utilisateur connectée
                localStorage.removeItem('temp_token')
                localStorage.setItem('token', token)
                
                let role = await api.role.get_auth_roles(token)
                let user = await api.user.get_auth_users(token)
                console.log('name', user.data.data.name)
                console.log('role', role.data.data[0])
                localStorage.setItem('name', user.data.data.name)
                localStorage.setItem('role', role.data.data)
                if (role.data.data[0].toUpperCase()=='RESPONSABLE POSTE' || role.data.data[0].toUpperCase()=='RESPONSABLE DISTRIBUTEUR'  ){
                    console.log('ok sans faute')
                    let solde = await api.entity.get_balance_entites(token)
                    console.log("mon solde ",solde)
                    localStorage.setItem('solde', solde.data.data.solde)
                    localStorage.setItem('type_entite', solde.data.data.typeentite_libelle)
                } else if (role.data.data[0].toUpperCase() == 'OPERATEUR POSTE' || role.data.data[0].toUpperCase() == 'OPERATEUR DISTRIBUTEUR'){
                    let solde = await api.atm.get_auth_guichets(token)
                    console.log(solde)
                    localStorage.setItem('solde', solde.data.data.solde)
                    localStorage.setItem('type_entite', solde.data.data.nom)
                } else if (role.data.data[0].toUpperCase() == 'SUPER ADMIN' || role.data.data[0].toUpperCase() == 'CHEF AGENCE'){
                    localStorage.setItem('solde',null)
                    localStorage.setItem('type_entite', null)
                }
                //get user all permissions
                
                //Récupérer le code sur le serveur
                //localStorage.setItem('secret_code',token)
                console.log('login response')
                console.log(response)
                commit('login_step_two', token)
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })    
    },
    login_step_keycloak({commit}, code,actions) { //step 2 to connect 
        return new Promise(async (resolve,reject)=>{
            api.auth.getUserPermissions(localStorage.getItem('token'))
                .then(async response => {
                    let perm = await api.auth.getUserPermissions(localStorage.getItem('token'))
                            
                        commit('update_permissions', perm.data.data) //met à jour les permissions de l'utilisateur connectée
                        localStorage.removeItem('temp_token')
                        //localStorage.setItem('token', localStorage.getItem('token'))            
                        let role = await api.role.get_auth_roles(localStorage.getItem('token'))
                        let user = await api.user.get_auth_users(localStorage.getItem('token'))
                        console.log('name', user.data.data.name)
                        console.log('role', role.data.data[0])
                        localStorage.setItem('name', user.data.data.name)
                        localStorage.setItem('role', role.data.data)
                        if (role.data.data[0].toUpperCase()=='RESPONSABLE POSTE' || role.data.data[0].toUpperCase()=='RESPONSABLE DISTRIBUTEUR'  ){
                            let solde = await api.entity.get_balance_entites(localStorage.getItem('token'))
                            console.log("mon solde ",solde)
                            localStorage.setItem('solde', solde.data.data.solde)
                            localStorage.setItem('type_entite', solde.data.data.typeentite_libelle)
                        } else if (role.data.data[0].toUpperCase() == 'OPERATEUR POSTE' || role.data.data[0].toUpperCase() == 'OPERATEUR DISTRIBUTEUR'){
                            let solde = await api.atm.get_auth_guichets(token)
                            console.log(solde)
                            localStorage.setItem('solde', solde.data.data.solde)
                            localStorage.setItem('type_entite', solde.data.data.nom)
                        } else if (role.data.data[0].toUpperCase() == 'SUPER ADMIN' || role.data.data[0].toUpperCase() == 'CHEF AGENCE'){
                            localStorage.setItem('solde',null)
                            localStorage.setItem('type_entite', null)
                        }
                        commit('login_step_two', token)
                        resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
         
    },
    logout({commit}){
        api.auth.disconnect_from_server()
        .then(response=>{
            localStorage.removeItem('token')
            localStorage.removeItem('temp_token')
            localStorage.removeItem('permissions')
            localStorage.removeItem('name')
            localStorage.removeItem('role')
            localStorage.removeItem('solde')
            localStorage.removeItem('type_entite')
            commit('logout')
        })
        .catch(error=>{
            localStorage.removeItem('token')
            localStorage.removeItem('temp_token')
            localStorage.removeItem('permissions')
            localStorage.removeItem('name')
            localStorage.removeItem('role')
            localStorage.removeItem('solde')
            localStorage.removeItem('type_entite')
            commit('logout')
        })
    },
    userPermissions() {
        api.auth.getUserPermissions().then(response => {
            console.log('rep ', response.data.data)
            commit('update_permissions',response.data.data)
        })
    },
    getUserInfo({ commit }, data) {
        api.auth.getUserInfo().then(response => {
            console.log('rep ', response.data.data)
            commit('userInfo', response.data.data)
            return response.data.data;
        })
    },
    forgetPassword({ commit }, data) {
        return api.auth.forgetPassword(data).then((response) => {
            console.log("forget password reponse : ",response.data)
            return response.data
        })
            .catch(error => {
                return error.response.data
            })
    },
    resetPassword({ commit }, data) {
        return api.auth.resetPassword(data).then((response) => {
            console.log("reset password reponse : ",response.data)
            //commit('addTypePiece', response.data.data)
            return response.data
        })
            .catch(error => {
                return error.response.data
            })
    }
    
}





export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
